export const TYPES = {
    NEXT_STEP: "NEXT_STEP", 
    BACK_STEP: "BACK_STEP",
    TO_STEP: "TO_STEP", 
    SET_FORM: "SET_FORM",
    SET_FORM_STEP_1: "SET_FORM_STEP_1",
    SET_FORM_STEP_2: "SET_FORM_STEP_2",
    SET_FORM_ERRORS_STEP_1: "SET_FORM_ERRORS_STEP_1",
    SET_FORM_ERRORS_STEP_2: "SET_FORM_ERRORS_STEP_2",
    SET_ERROR_TEXT: "SET_ERROR_TEXT"
};